const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGysj(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.4,165.8c3.6.2,7.1,1.2,10.7,3,.7.3,1.1,1.1,1.1,1.8v29.9c0,1.1-.9,2-2,2h-22.5c-1.1,0-2-.9-2-2v-29.9c0-.8.4-1.5,1.1-1.8,3.6-1.8,7.1-2.8,10.7-3v15.8c0,.8.7,1.5,1.5,1.5.8,0,1.5-.7,1.5-1.5v-15.8h0Z",
    style: {
      fill: "#465566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,176c1,0,1.8.7,2,1.6l3.5,14.9c.3,1.1-.4,2.2-1.5,2.5-.2,0-.3,0-.5,0h-36.9c-1.1,0-2-.9-2-2,0-.1,0-.3,0-.4l3.3-14.9c.2-.9,1-1.6,2-1.6h30.2Z",
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.3,137c1.1,0,2,.9,2,2v9.9h16.5c5.7,0,8.9,2.7,8.6,7.7v9h-3.1v-9.1c.2-3.2-1.4-4.6-5.6-4.6h-16.5s0,23,0,23l5.6,25c.2,1.1-.4,2.2-1.6,2.4-.1,0-.3,0-.4,0h-56.3c-1.1,0-2-.9-2-2.1,0-.1,0-.3,0-.4l5.6-24.9v-36.1c0-1.1.9-2,2.1-2h45.1ZM176.3,152.1h-43v23.8c0,0-5.4,23.7-5.4,23.7h53.8l-5.4-24.1v-23.3h0ZM176.3,140.1h-43v8.9h43v-8.9h0Z",
    style: {
      fill: "#465566"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,125.8c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5,0-2.5,2-4.5,4.5-4.5Z",
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,109.6c5,0,9,4,9,9s-4,9-9,9h0c-5,0-9-4-9-9s4-9,9-9Z",
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,201.2c-1.1,0-2-.9-2-2,0,0,0,0,0-.1l4.4-78.5c0-1.1,1-1.9,2-1.9h23.8c1.1,0,2,.8,2,1.9l4.4,78.5c0,1.1-.8,2.1-1.9,2.2,0,0,0,0,0,0h0s-32.6,0-32.6,0h0ZM113,121.7h-21.8l-3,52.9h27.7l-3-52.9h0ZM95.6,107.8h13.1c1.5,0,2.7,1.2,2.7,2.7,0,1.5-1.2,2.7-2.7,2.7h-13.1c-1.5,0-2.7-1.2-2.7-2.7,0-1.5,1.2-2.7,2.7-2.7h0ZM97.2,99.5h9.8c1.1,0,2,.9,2,2s-.9,2-2,2h-9.8c-1.1,0-2-.9-2-2s.9-2,2-2Z",
    style: {
      fill: "#465566"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M213,244.7c3,6.6,7.1,12.6,12.1,17.7l-57,32.9c-10.8,6.2-24,6.2-34.7,0l-52.5-30.3c5.4-4.9,9.8-10.6,13.2-17.1l50,28.9c4.1,2.4,9.2,2.4,13.4,0l55.6-32.1ZM86.7,37.8c.4,7.7,2.2,15,5.2,21.7l-45,25.9-.9.6c-3.6,2.5-5.8,6.6-5.8,11v62.4c-7.5,0-14.7,1.4-21.4,3.9v-66.3c0-12.4,6.6-23.9,17.4-30.1l50.4-29.1ZM207.8,33.7l57.5,33.2c10.7,6.2,17.4,17.7,17.4,30.1v64.1c-7-1.7-14.2-2.1-21.4-1.3v-62.9c0-4.8-2.5-9.2-6.7-11.6l-50.7-29.3c2.7-7.2,4-14.8,3.9-22.5h0Z",
    style: {
      fill: "#024dc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,174.9c-20.8,0-37.7,16.9-37.7,37.7s16.9,37.7,37.7,37.7,37.7-16.9,37.7-37.7-16.9-37.7-37.7-37.7ZM37.7,232.3c-10.9,0-19.7-8.8-19.7-19.7s8.8-19.7,19.7-19.7,19.7,8.8,19.7,19.7-8.8,19.7-19.7,19.7Z",
    style: {
      fill: "#024dc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.4,0C127.6,0,110.8,16.9,110.8,37.7s16.9,37.7,37.7,37.7,37.7-16.9,37.7-37.7S169.2,0,148.4,0ZM148.4,57.3c-10.9,0-19.7-8.8-19.7-19.7s8.8-19.7,19.7-19.7,19.7,8.8,19.7,19.7-8.8,19.7-19.7,19.7Z",
    style: {
      fill: "#024dc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,174.9c-20.8,0-37.7,16.9-37.7,37.7s16.9,37.7,37.7,37.7,37.7-16.9,37.7-37.7-16.9-37.7-37.7-37.7ZM262.3,232.3c-10.9,0-19.7-8.8-19.7-19.7s8.8-19.7,19.7-19.7,19.7,8.8,19.7,19.7-8.8,19.7-19.7,19.7Z",
    style: {
      fill: "#024dc4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGysj);
export default __webpack_public_path__ + "static/media/gysj.4938500b5a03d72993c5e8fe93c3662f.svg";
export { ForwardRef as ReactComponent };